import { useTranslations } from 'next-intl';
import { Container, CustomImage as Image } from '..';
import styles from './Lifestyle.module.css';

export const LifeStyle = ({ className }: { className?: string }) => {
  const t = useTranslations('ring');
  return (
    <section className={className ? `${styles.root} ${className}` : styles.root}>
      <Container>
        <div className={styles.title}>
          <h4>{t('lifestyle.subheading.worldMostComfortable')}</h4>
        </div>
        <div className={styles.imgGrid}>
          <div className={styles.img}>
            <Image
              src="web_v2/lifestyle/lifestyle-1.png/w_1600"
              alt={t('lifestyle.image.alt.lifestyle')}
              layout="fill"
              objectFit="cover"
            />
          </div>
          <div className={`${styles.section} ${styles.small}`}>
            <div className={styles.img}>
              <Image
                src="web_v2/lifestyle/lifestyle-2.png/w_1600"
                alt={t('lifestyle.image.alt.lifestyle')}
                layout="fill"
                objectFit="cover"
              />
            </div>
            <p className={styles.text}>
              <span>{t('lifestyle.text.glidesYouYour')}</span>{' '}
              {t('lifestyle.text.itThereWhen')}
            </p>
          </div>
          <div className={styles.section}>
            <div className={styles.img}>
              <Image
                src="web_v2/lifestyle/lifestyle-3.png/w_1600"
                alt={t('lifestyle.image.alt.lifestyle')}
                layout="fill"
                objectFit="cover"
              />
            </div>
            <p className={styles.text}>
              <span>{t('lifestyle.text.formFactorDiscreet')}</span>{' '}
              {t('lifestyle.text.hardIgnoreIts')}
            </p>
          </div>
        </div>
      </Container>
    </section>
  );
};
